"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-open-book.tsx
var OpenBookIcon = function OpenBookIcon(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.14987C1 3.75468 1.23273 3.39656 1.59386 3.23606L2.25089 2.94405C4.31941 2.0247 6.68058 2.0247 8.74911 2.94405L9.40614 3.23606C9.76727 3.39656 10 3.75468 10 4.14987V18.0126C10 18.7121 9.27999 19.18 8.64075 18.8959V18.8959C6.64121 18.0072 4.35879 18.0072 2.35925 18.8959V18.8959C1.72001 19.18 1 18.7121 1 18.0126V4.14987Z",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M4 6.86937C4.95497 6.55105 6.04503 6.55105 7 6.86937",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M4 10.8694C4.95497 10.551 6.04503 10.551 7 10.8694",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    d: "M18.2582 3.17041L18.4061 3.23618C18.7673 3.39668 19 3.7548 19 4.14999V17.9614C19 18.5136 18.5523 18.9614 18 18.9614C17.8601 18.9614 17.7217 18.932 17.5939 18.8752L16.75 18.5001C15.3176 17.8635 13.6824 17.8635 12.25 18.5001L11.4061 18.8752C10.9015 19.0995 10.3105 18.8722 10.0862 18.3675C10.0294 18.2396 10 18.1013 10 17.9614V4.14999",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _preact.h)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.83377C10 2.62281 10.0959 2.42328 10.2606 2.29149V2.29149C11.6655 1.16762 13.5276 0.793596 15.2574 1.28784L15.4594 1.34555C15.7794 1.43697 16 1.72943 16 2.0622V15.8432C16 16.1724 15.685 16.41 15.3685 16.3196V16.3196C13.6699 15.8343 11.8538 16.5339 10.9175 18.032V18.032C10.6534 18.4546 10 18.2687 10 17.7703V2.83377Z",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinejoin: "round"
  }));
};

var _default = OpenBookIcon;
exports.default = _default;